import isEqual from 'lodash.isequal'

import { removeFalsySearchParams } from '../../utils/filterUtils'

export const cachedLoadsPaginationSize = 14

export const COLUMNS_NAME = {
  NEGOTIATION: 'negotiation',
  HIRED: 'waitingCollect',
  IN_TRANSIT: 'inTransit',
  IN_PROGRESS: 'inProgress',
  DELIVERED: 'delivered',
}

export const cachedLoadStateSchema = {
  list: [],
  page: 1,
  hasMore: true,
  count: 0,
  sortDirection: 'DESC',
  renderException: false,
}

export const initialLoadsFilterState = {
  operationGroups: [],
  searchStatus: [],
  collectUF: '',
  deliveryUF: '',
  initCollectDate: null,
  endCollectDate: null,
  waitingAtLogisticOperator: false,
  trackingStatus: null,
  flProposalSended: false,
  flShippingNotViewed: false,
  flLotAvailable: false,

  text: '',
}


export const formatPayloadBySearchAdvanced = (currentFilters) => {
  const cleanedFilters = removeFalsySearchParams(currentFilters)
  const filteredKeys = Object.keys(cleanedFilters).filter(
    (key) => key !== 'text' && key !== 'operationGroups',
  )

  return {
    ...cleanedFilters,
    searchAdvanced: !!filteredKeys.length,
  }
}

export const formatCachedLoadsPayload = (filters, defaults) => {
  const {
    operationGroups,
    searchStatus: status,
    collectUF,
    deliveryUF,
    trackingStatus,
    waitingAtLogisticOperator,
    flProposalSended,
    flShippingNotViewed,
    searchAdvanced = defaults.searchAdvanced,
    flLotAvailable,
    page = 1,
    size = cachedLoadsPaginationSize,
    ...rest
  } = filters

  const operations = operationGroups.length ? operationGroups : defaults.operationIds
  const searchStatus = status || undefined

  return {
    page,
    size,
    ...rest,
    operationGroups: operations,
    searchStatus,
    collectUF: collectUF || undefined,
    deliveryUF: deliveryUF || undefined,
    trackingStatus: trackingStatus || undefined,
    waitingAtLogisticOperator: waitingAtLogisticOperator || undefined,
    flProposalSended: flProposalSended || undefined,
    flShippingNotViewed: flShippingNotViewed || undefined,
    flLotAvailable: flLotAvailable || undefined,
    searchAdvanced,
  }
}
